module.exports = __webpack_public_path__ + "media/images/backgrounds/how_to/lady3-7742619f6d923a328fffd602d95800b1.svg";